import { useEffect, useRef, useState } from "react";
import { Terminal } from "xterm";
import { FitAddon } from "xterm-addon-fit";
import "xterm/css/xterm.css";

import { Box, CssBaseline, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { socket } from "./socket-hook"; // your custom socket instance

export default function SSHTerminal() {
  const data = JSON.parse(window.name || "{}");
  const title = data.title;
  const ip = data.ip;

  const terminalRef = useRef(null);
  const fitAddonRef = useRef(null);
  const termRef = useRef(null);

  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!ip || !terminalRef.current) return;

    const term = new Terminal({
      fontFamily: "FiraCode Nerd Font",
      cursorBlink: true,
      allowTransparency: true,
      fontSize: 14,
      theme: {
        background: "#121a24",
        foreground: "#f5f5f5",
      },
    });

    const fitAddon = new FitAddon();
    fitAddonRef.current = fitAddon;
    termRef.current = term;

    term.loadAddon(fitAddon);
    term.open(terminalRef.current);
    fitAddon.fit();

    socket.connect();

    socket.on("connect", () => {
      setConnected(true);
      socket.emit("connection", ip);
    });

    setTimeout(
      () => socket.emit("resize", { cols: term.cols, rows: term.rows }),
      1000
    );

    socket.on("disconnect", () => {
      setConnected(false);
    });

    term.onData((data) => {
      socket.emit("input", data);
    });

    socket.on("output", (data) => {
      term.write(data);
    });

    const handleResize = () => {
      if (!fitAddonRef.current || !termRef.current) return;
      fitAddonRef.current.fit();
      socket.emit("resize", {
        cols: termRef.current.cols,
        rows: termRef.current.rows,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      socket.off("connect");
      socket.off("disconnect");
      socket.off("output");
      term.dispose();
      socket.disconnect();
    };
  }, [ip]);

  return (
    <>
      <Helmet title={`${title} | ${ip}`} />
      <CssBaseline />
      {!connected && (
        <Typography
          variant="h6"
          sx={{
            color: "gray",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 10,
          }}
        >
          No connection...
        </Typography>
      )}

      <Box
        ref={terminalRef}
        sx={{
          boxSizing: "border-box",
          height: "100vh",
          width: "100%",
          padding: "5px 0 0 5px",
          backgroundColor: "#121a24",
          opacity: connected ? 1 : 0.1,
          pointerEvents: connected ? "auto" : "none",
          "& .xterm-viewport": {
            overflowY: "auto !important",
            scrollbarWidth: "thin",
          },
          "& .xterm-viewport::-webkit-scrollbar": {
            width: "6px",
          },
          "& .xterm-viewport::-webkit-scrollbar-thumb": {
            backgroundColor: "#444",
            borderRadius: "4px",
          },
        }}
      />
    </>
  );
}
